// extracted by mini-css-extract-plugin
export var active = "_ea-7";
export var container = "_ea-0";
export var evenWidth = "_ea-4";
export var large = "_ea-5";
export var outlet = "_ea-8";
export var slide = "_ea-2";
export var small = "_ea-6";
export var tab = "_ea-3";
export var tabs = "_ea-1";